import { createSelector } from "reselect";
import { CatalogEndpointsType, CATALOG_SECTIONS_INFO } from "..";
import { getEndpoints } from "../catalog-page-selectors";

export const getColumns = createSelector(
  getEndpoints,
  (endpoints: CatalogEndpointsType) => CATALOG_SECTIONS_INFO[endpoints].columns
);
